(ns practitest.frontend.xbot.agents-view.av-common)

(def color-busy "#fc9700")
(def color-load1 "#03495d")
(def color-load5 "#188493")
(def color-load15 "#3fb9c2")

(defn agent-view-titles [title]
  [:p.agent-view-titles
   title])

(defn display-underline [{:keys [online? busy? enabled?]} bottom top]
  [:hr.underline.col-sm-12.col-md-12.col-lg-12.no-padding-sides
   {:style {:margin              "0px"
            :min-width (when (or top bottom) "580px")
            :border-bottom-width "2px"
            :border-bottom-style "solid"
            :border-bottom-color (if busy?
                                   color-busy
                                   (if (and online? enabled?) "green" "grey"))}
    :class (when bottom "bottom-underline")}])
